import type {
  ForgotPasswordInput,
  LoginInput,
  LoginResponse,
  MeResponse,
  ResetPasswordInput,
} from '@i9portal/shared';
import { api } from '../client';

export const authApi = {
  login: (input: LoginInput) =>
    api.post<LoginResponse>('/auth/login', input, { withCredentials: true, skipAuthRefresh: true }),
  logout: () =>
    api.post<void>('/auth/logout', {}, { withCredentials: true, skipAuthRefresh: true }),
  me: () => api.get<MeResponse>('/auth/me'),
  forgotPassword: (input: ForgotPasswordInput) =>
    api.post<void>('/auth/forgot-password', input, { skipAuthRefresh: true }),
  resetPassword: (input: ResetPasswordInput) =>
    api.post<void>('/auth/reset-password', input, { skipAuthRefresh: true }),
};
